import { ReactNode } from "react";
import styles from "./NewAssetButtonWrapper.module.css";

type Props = {
  children: ReactNode;
};

export function NewAssetButtonWrapper({ children }: Props) {
  return <div className={styles.root}>{children}</div>;
}
